<template>
    <div class="main course">
        <Calendar ref="Calendar" :sundayStart="true" v-on:choseDay="clickDay" v-on:changeMonth="changeDate"></Calendar>        
        <van-radio-group v-model="radio" class="timebox tac mtn fs2">
            <van-row>
                <van-col v-for="(item,index) in columns" :key="item.id" span="12" class="time">
                    <van-radio :name="index">{{item.startTime}}:00 - {{item.endTime}}:00</van-radio>
                </van-col>
            </van-row>
        </van-radio-group>
        
        <div class="clear buybar" style="background:#f6f6f6;">
          <div class="buybar__content clear">
            <van-button size="large" type="primary" @click="sure">确定</van-button>
          </div>
        </div>
        
        <!-- <van-popup v-model="show" position="bottom">
          <van-nav-bar
            :title="onclickDay"
            left-text="取消"
            right-text="确定预约"
            @click-left="show = false"
            @click-right="onClickRight"
          />
          <van-picker :columns="columns" @change="onChange" />
        </van-popup> -->
    </div>
</template>
<script>
import Vue from 'vue';
import { Field,Button,Toast,Popup,NavBar,Picker,RadioGroup, Radio } from 'vant';
import Calendar from '@/components/calendar-component/index';
import moment from 'moment';
import Func from "@/assets/scripts/func";
moment.locale('zh-cn');

Vue.use(Field).use(Button).use(Toast).use(Popup).use(NavBar).use(Picker).use(RadioGroup).use(Radio);

export default {
    name: 'CourseAppointment',
    data(){
        return { 
            show:false,         
            columns: [],  // 预约时间段
            onclickDay: moment(new Date()).format('YYYY-MM-DD'),//默认日期今天
            radio: 0, 
            coachid:''
        }
    },
    created(){
        if(this.$route.params.coachId != '-1'){
            this.coachid = this.$route.params.coachId
        }
        let _this = this;
        // 获取预约时间
        this.$http.post('club_user_reserve/getTimeList',{
            clubId:sessionStorage.getItem("CLUBID"),
            type:this.$route.params.type,
            coachId:this.coachid
        }).then(function(res){
            // console.log(res)
            _this.columns = res.data.value
        })
    },
    components: {
       Calendar
    },
    methods: {
      clickDay(data) {
        // Toast('选中了' + data);                
        this.onclickDay = moment(data).format('YYYY-MM-DD');  //给预约弹出层title赋值日期     
      },
      // clickToday(data) {
      //   console.log('跳到了本月今天', data); //跳到了本月
      // },
      changeDate(data) {
        // Toast('切换到的月份为' + data);
        this.month = moment(data).format('YYYY/MM');  //月份赋值
        
      },
      sure() {
          let _this = this;
        //验证是否登录
        if (!Func.isSetCookie('_ibl')) {
        //   this.$router.push({ name: 'login', query: { redirect: location.href }})
          location.href = `${location.origin}/m/login?redirect=${encodeURIComponent(location.href)}`
          return
        }
        //签约
        var starttime=this.onclickDay+' '+this.columns[this.radio].startTime+':00:00';
        var endtime=this.onclickDay+' '+this.columns[this.radio].endTime+':00:00';
        
        this.$http.post('club_user_reserve/reserve',{
            orderId:this.$route.params.orderId,
            itemId:this.$route.params.itemId,
            type:this.$route.params.type,
            startTime:starttime,
            endTime:endtime
        }).then(function(res){
            // console.log(res)
            if(!res.data.code){
                //跳转到预约列表
                Toast('预约成功！')
                _this.$router.push({name: 'myreserved',params:{clubId:sessionStorage.getItem("CLUBID"),type:_this.$route.params.type}});
                // _this.$router.go(-1)
            }else{
                Toast.fail(res.data.message)
            }
        })
      },
      onClickRight() {
        Toast('预约成功');
        this.show = false;
      },
      onChange(picker, value, index) {
        Toast(`当前值：${value}, 当前索引：${index}`);
      }
  }
}
</script>
<style lang="less">
.course-container{
  padding: 0 .15rem;
}
.timebox .time{
    padding: .1rem;
    & .van-radio__input{
        height: auto;
        vertical-align: top;
    }
    & .van-radio .van-icon-checked{
        color: #4b0;
    }
}
@supports (bottom: constant(safe-area-inset-bottom)) or (bottom: env(safe-area-inset-bottom)) {
  .buybar {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/CourseAppointment.vue